"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var CnLogo = function CnLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "170.1px",
    height: "170.1px",
    viewBox: "0 0 170.1 170.1"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M33.6,79.7c-0.8,0-1.4,0.2-2,0.6c-0.6-2.2-2.6-3.5-5.6-3.5h-4.7v1.6h4.8c2.5,0,3.9,1.3,3.9,3.7 s-1.5,3.7-3.9,3.7h0l0.3-0.4c0.6-0.9,1.1-1.8,1.1-2.6c0-1.7-1.1-3-3.2-3c-1.8,0-3.2,1.4-3.2,3.1h1.8c0-0.8,0.5-1.4,1.5-1.4 c1,0,1.5,0.6,1.5,1.4c0,0.6-0.4,1.3-0.9,2l-0.7,1h-2.9v1.6H23l-3.1,4.5h7.4v-1.7H23l2-2.9h1c0.2,0,0.3,0,0.5,0l5.2,6.7h2.2 l-1.7-2.2l3.2-4.7c0.8-1.2,1.8-2.4,1.8-3.9C37.2,81.3,35.7,79.7,33.6,79.7z M31.1,90.5L28.4,87c1-0.3,1.8-0.8,2.3-1.5 c0.6,0.8,1.6,1.3,2.8,1.3h0.1L31.1,90.5z M33.6,85.2c-1.1,0-1.8-0.8-1.8-1.9c0-0.1,0-0.2,0-0.3v-0.1c0.1-0.9,0.8-1.6,1.8-1.6 c1.1,0,1.8,0.8,1.8,1.9C35.4,84.3,34.7,85.2,33.6,85.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M28,71.2c-7.6,0-13.8,6.2-13.8,13.8c0,7.6,6.2,13.8,13.8,13.8S41.9,92.7,41.9,85C41.9,77.4,35.6,71.2,28,71.2 L28,71.2z M28,97.2c-6.7,0-12.2-5.5-12.2-12.2c0-6.7,5.5-12.2,12.2-12.2S40.2,78.3,40.2,85C40.2,91.8,34.8,97.2,28,97.2z M58.4,85 c0.7-0.6,1.1-1.5,1.1-2.5s-0.4-1.9-1.1-2.5C57.8,79.4,57,79,55.7,79h-4.5v12.3h2.4v-5.4h0.9l4.4,5.4h2.9l-4.6-5.6 C57.6,85.5,58,85.3,58.4,85z M56.7,83.4c-0.2,0.2-0.5,0.4-1.2,0.4h-2v-2.6h2c0.7,0,1,0.2,1.2,0.4C57.2,82.1,57.2,82.9,56.7,83.4z M65.7,85.8h3.8v-2.1h-3.8v-2.5h5V79h-7.3v12.3h7.5v-2.1h-5.2L65.7,85.8z M74,91.3h2.4v-5.5h3.8v-2.1h-3.8v-2.5h5V79H74L74,91.3z M83.8,79h2.4v12.3h-2.4V79z M98,87l-6.8-8h-1.7v12.3h2.4v-8l6.8,8h1.7V79H98V87z M106.3,85.8h3.8v-2.1h-3.8v-2.5h5V79H104v12.3 h7.5v-2.1h-5.2V85.8z M121.7,85c0.7-0.6,1.1-1.5,1.1-2.5s-0.4-1.9-1.1-2.5c-0.6-0.6-1.4-0.9-2.7-0.9h-4.5v12.3h2.4v-5.4h0.9 l4.3,5.4h2.9l-4.6-5.6C121,85.5,121.4,85.3,121.7,85z M120.1,83.4c-0.2,0.2-0.5,0.4-1.2,0.4h-2v-2.6h2c0.7,0,1,0.2,1.2,0.4 c0.2,0.3,0.3,0.6,0.3,1C120.5,82.8,120.3,83.1,120.1,83.4z M130,83.3l-2.7-4.3h-2.7l4.2,6.7v5.5h2.4v-5.5l4.2-6.7h-2.7L130,83.3z M143.5,86c0.9-1.1,1.3-2.1,1.3-3.6c0-2.2-1.9-3.9-4-3.9h-0.1c-2.1,0-3.9,1.6-4,3.8h2.4c0-0.9,0.8-1.7,1.7-1.7 c0.9,0,1.7,0.8,1.7,1.7c0,0.6-0.1,1.3-1,2.4l-5.3,6.4h9v-2.1h-4.3L143.5,86z M151.4,78.6c-2.4,0-4.4,2-4.3,4.4 c0,2.3,1.8,4.3,4.2,4.3c0,0,0.1,0,0.1,0h0.2l-2.3,4h2.6l2.9-5c0.6-1.1,1.2-2.2,1.2-3.4C155.9,80.3,153.7,78.6,151.4,78.6z M151.4,85.2c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2C153.6,84.2,152.7,85.2,151.4,85.2z"
  })));
};
CnLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
CnLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = CnLogo;